/**
 * Click-to-chat link for the help desk.
 *
 * Uses WhatsApp's wa.me link, which opens the app on mobile and WhatsApp Web on
 * desktop — no WhatsApp Business API, SDK or third-party widget involved.
 *
 * Configure with REACT_APP_WHATSAPP_NUMBER (help desk number in international
 * format) and optionally REACT_APP_WHATSAPP_MESSAGE (text the chat opens with).
 *
 * Returns null when no number is configured, so each caller can decide whether
 * to hide its control or leave it inert rather than linking somewhere broken.
 */
export const getHelpDeskChatUrl = () => {
  // wa.me accepts digits only — no +, spaces, dashes or brackets — so whatever
  // format the number is stored in is normalised here rather than in the env.
  const helpDeskNumber = (process.env.REACT_APP_WHATSAPP_NUMBER || "").replace(/\D/g, "");

  if (!helpDeskNumber) {
    // Warn rather than fail silently — an unset variable is otherwise
    // indistinguishable from the control being broken.
    if (process.env.NODE_ENV === "development") {
      console.warn(
        "[helpDeskChat] no chat link: set REACT_APP_WHATSAPP_NUMBER in .env and restart the dev server.",
      );
    }
    return null;
  }

  const prefilledMessage = process.env.REACT_APP_WHATSAPP_MESSAGE || "Hi, I need help with TDP.";

  return `https://wa.me/${helpDeskNumber}?text=${encodeURIComponent(prefilledMessage)}`;
};
